import React from "react";

import { MemberProfileActivityEntry } from "../../../component-library";

export const EmailUpdatedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { admin_id, admin_name, new_email, old_email } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="EmailUpdatedIcon"
      iconSrc="activate_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle="Email Updated"
      title="Admin Update"
    >
      <div className="fs-14">
        <div>{`Old Email: ${old_email}`}</div>
        <div>{`New Email: ${new_email}`}</div>
        <div>{`Action Taken By: ${admin_name} (${admin_id})`}</div>
      </div>
    </MemberProfileActivityEntry>
  );
};

export const PasswordResetActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const { admin_id, admin_name } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="PasswordResetIcon"
      iconSrc="activate_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle="Admin Password Reset"
      title="Admin Update"
    >
      <div className="fs-14">
        <div>{`Action Taken By: ${admin_name} (${admin_id})`}</div>
      </div>
    </MemberProfileActivityEntry>
  );
};

export const PracticeChangedActivity = (props) => {
  const { keyContent, localCreatedTime } = props;
  const {
    admin_id,
    admin_name,
    new_pcp_id,
    new_pcp_name,
    new_pcp_practice_id,
    old_pcp_id,
    old_pcp_name,
    old_pcp_practice_id,
  } = keyContent;

  return (
    <MemberProfileActivityEntry
      headerClassName="apti-MemberProfileActivityEntry__Header__Dark"
      iconAlt="PracticeChangedIcon"
      iconSrc="activate_timeline.svg"
      localDateTime={localCreatedTime}
      subTitle="Patient Practice Changed"
      title="Admin Update"
    >
      <div className="fs-14">
        <div>{`Old PCP Id: ${old_pcp_id}`}</div>
        <div>{`New PCP Id: ${new_pcp_id}`}</div>
        <div>{`Old PCP Practice Id: ${old_pcp_practice_id}`}</div>
        <div>{`New PCP Practice Id: ${new_pcp_practice_id}`}</div>
        <div>{`Old PCP Name: ${old_pcp_name}`}</div>
        <div>{`New PCP Name: ${new_pcp_name}`}</div>
        <div>{`Action Taken By: ${admin_name} (${admin_id})`}</div>
      </div>
    </MemberProfileActivityEntry>
  );
};
